export default __webpack_public_path__ + "fef568f64dd5a32ab65b9d9dab41e672.ttf";